import React, { Component } from 'react'
import { observer } from 'mobx-react'
import moment from 'moment'

import Button from '../../../UniformComponents/Button'
import Panel from '../../../UniformComponents/Panel'
import DataTable from '../../DataTable'
import Checkbox from '../../form/Checkbox'
import Date from '../../form/Date'

@observer
class EmailSchedule extends Component {
    constructor(props) {
        super(props)
        this.intranetStore = props.intranetStore
    }

    componentDidMount() {
        const { store } = this.props
        this.intranetStore.getEmailList()
        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'emailSchedule',
                url: '/intranet/emailSchedule',
                title: 'Email Schedule',
            },
        ]
    }

    renderDataTable = () => {
        const { emailData, emailScheduleTableColumns } = this.intranetStore
        if (emailData.length > 0) {
            return (
                <DataTable
                    store={{ filteredList: emailData }}
                    dataSet={emailData}
                    columns={emailScheduleTableColumns}
                    inMemory
                />
            )
        }
        return <div>There are no emails</div>
    }

    renderFilters = () => {
        const {
            handleChangeEmailRequest,
            handleCheckedEmailStatus,
            getEmailList,
            emailStatuses,
            emailFilterRequest,
        } = this.intranetStore
        return (
            <Panel style={{ width: '250px' }}>
                <div>
                    <Date
                        label="From"
                        onBlur={(value) => handleChangeEmailRequest(value, 'startDate')}
                        placeholder={moment(emailFilterRequest.dateFrom).format('DD/MM/YYYY')}
                        dateFormat="DD/MM/YYYY"
                        allowManualDateEdit
                    />
                    <br />
                    <Date
                        label="Select To"
                        onBlur={(value) => handleChangeEmailRequest(value, 'endDate')}
                        placeholder={moment(emailFilterRequest.dateTo).format('DD/MM/YYYY')}
                        dateFormat="DD/MM/YYYY"
                        allowManualDateEdit
                    />
                </div>
                <div className="statusFilters">
                    {emailStatuses.map((status) => (
                        <Checkbox
                            label={status.label}
                            name={status.name}
                            defaultChecked
                            onBlur={handleCheckedEmailStatus}
                        />
                    ))}
                </div>

                <Button
                    onClick={() => getEmailList()}
                    label="Filter"
                    cssClass="regular primary"
                />
            </Panel>
        )
    }

    render() {
        return (
            <div id="emailSchedule">
                <div>
                    <div style={{ display: 'flex', gap: 20 }}>
                        <div>
                            <div style={{ display: 'flex' }}>
                                {this.renderFilters()}
                            </div>
                        </div>
                        <div>
                            <div style={{ display: 'flex' }}>
                                <Panel style={{ overflow: 'auto' }}>
                                    {this.renderDataTable()}
                                </Panel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default EmailSchedule
